import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./permission.actions";
import * as fromGraphql from "./permission.graphql";


@Injectable()
export class PermissionEffects {
  getSystemPermissions = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getSystemPermissions),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SYSTEM_PERMISSIONS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching system permissions'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadPermissions({ permissions: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService
  ) {}
}
